module.exports = __webpack_public_path__ + "img/logo_Q_Platform.81f1aeba.svg";